import { Page, PageContent } from '@/components/layout/page';
import { ErrorBanner } from './error-banner';
import { errorContainer } from './page.css';

export const ErrorPage = ({
  primaryAction,
  secondaryAction,
}: {
  primaryAction?: React.ReactNode;
  secondaryAction?: React.ReactNode;
}) => {
  return (
    <Page>
      <PageContent className={errorContainer}>
        <ErrorBanner
          primaryAction={primaryAction}
          secondaryAction={secondaryAction}
        />
      </PageContent>
    </Page>
  );
};
